import type { BankAccountView, BaseResponse } from 'models';

import { baseApi } from 'shared/api';

const transformBankAccountsResponse = (
  response: BaseResponse<BankAccountView[]>
) => response.Data;

export const bankAccountsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getDefaultPortalBankAccountsList: build.query<BankAccountView[], string>({
      query: (coopId) => ({
        url: `/cooperatives/${coopId}/bank-accounts`,
        method: 'GET',
      }),
      transformResponse: transformBankAccountsResponse,
      serializeQueryArgs: ({ endpointName }) => endpointName,
    }),
    getInvestorPortalBankAccountsList: build.query<BankAccountView[], string>({
      query: (coopId) => ({
        url: `/portfolios/${coopId}/bank-accounts`,
        method: 'GET',
      }),
      transformResponse: transformBankAccountsResponse,
      serializeQueryArgs: ({ endpointName }) => endpointName,
    }),
  }),
});
